<template>
  <div class="container">
    <div class="swipper">
      <el-carousel height="345px" :interval="3000" trigger="click">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img class="swipper-img" :src="item.thumbnail" alt="banner" />
          <div class="desc">
            <a @click="toDetail(item)">{{item.title}}</a>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="news-wrapper">
      <div class="news-header">
        <div class="header-item" v-for="(item, index) in columnList" :key="index"
          :class="showColumnIndex === index ? 'header-item-active' : ''" @mouseover="columnMouseover(index)"
          @click="toList(item.id)">
          {{item.name}}
        </div>
      </div>

      <div v-for="(item, index) in contentList" :key="index" v-show="showColumnIndex === index"
        style="min-height: 221px">
        <div v-for="(news, index) in item" :key="news.id"
          :class="showNewsDesc === news.id ? 'news-item-desc' : 'news-item-line'"
          :style="(showNewsDesc === news.id && index !== 0) ? { borderTop: '1px solid #ccc' } : ''"
          @mouseover="newsMouseover(news.id)" @click="toDetail(news, showColumnIndex === 0)">
          <span class="news-content"><strong style="font-size: 10px">· </strong>
            <span :class="showNew(news.check_time)">{{news.title | titleFilter}}</span>
          </span>

          <span style="flex-shrink: 0;font-size: 10px">{{showNewsDesc === news.id ? news.subtitle :
            news.check_time}}</span>
        </div>
      </div>
      <div class="img" @click="toSzf()">
        <img width="100%" height="77px" src="../assets/img/zhengfu-link.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
export default {
  name: 'Washington',
  props: {
    washingtonProps: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      bannerList: [],
      contentList: [],
      columnList: [],
      showColumnIndex: 1,
      showNewsDesc: 0,
      szfNewsList: []
    }
  },
  filters: {
    titleFilter (title) {
      return title.replace(/<br \/>/, '')
    }
  },
  watch: {
    washingtonProps: function (data) {
      if (data === null) {
        return
      }

      if (data.bannerList && data.bannerList.length > 0) {
        this.bannerList = data.bannerList
      }

      if (data.newsList && data.newsList.length > 0) {
        const newsList = data.newsList
        const columnList = []
        const contentList = []

        newsList.forEach(news => {
          columnList.push(news)
          contentList.push(news.content.slice(0, 5))
        })
        this.columnList = columnList
        this.contentList = contentList
        // this.showNewsDesc = contentList[0][0].id
        // this.getSzfNews()
      }
    }
  },
  methods: {
    toSzf () {
      window.open('https://www.sc.gov.cn/')
    },
    // 爬取省政府新闻
    async getSzfNews () {
      axios.get('/static/szf').then(resp => {
        const htmlDom = $(resp.data)
        const news = htmlDom.find('#dash-table li a')
        const times = htmlDom.find('#dash-table li span')
        news.splice(0, 7).forEach((item, index) => {
          this.szfNewsList.push({
            id: index,
            title: item.innerText,
            url: `https://www.sc.gov.cn${item.pathname}`,
            check_time: times[index].innerText.replace('(', '').replace(')', '')
          })
        })
        this.contentList.unshift(this.szfNewsList)
        this.columnList.unshift({
          name: '省政府信息'
        })
      })
    },
    showNew (time) {
      const str = time.replace(/-/g, '/')
      const createTime = new Date(str)
      const date = new Date()
      // 三天内
      if (createTime.getTime() <= date.getTime() && date.getTime() <= (createTime.getTime() + 259200000)) {
        return 'new'
      }
      return ''
    },
    columnMouseover (index) {
      this.showColumnIndex = index
      this.showNewsDesc = this.contentList[index][0].id
    },
    newsMouseover (id) {
      this.showNewsDesc = id
    },
    toList (id) {
      this.$router.push(`/news/${id}`)
      // if (this.showColumnIndex !== 0) {
      //   this.$router.push(`/news/${id}`)
      // } else {
      //   window.open('https://www.sc.gov.cn/10462/c109616/comlist_15.shtml')
      // }
    },
    toDetail (item, isSZF = false) {
      // eslint-disable-next-line no-unreachable
      if (!item.url) {
        this.$router.push(`/content/${item.id}`)
      } else {
        window.open(item.url)
      }
    }
  }
}
</script>
<style scoped>
@keyframes text {
  0%{
    color: red;
  }
  50%{
    color: pink;
  }
  100%{
    color: red;
  }
}
.swipper >>> .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  opacity: .48;
}

.swipper >>> .el-carousel__indicators--horizontal {
  left: 81%;
}

.swipper >>> .is-active .el-carousel__button {
  opacity: 1;
}

.swipper >>> .el-carousel__arrow {
  font-size: 24px;
}

.container {
  /*width: 1290px;*/
  width: 1180px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

  .swipper {
  width: 495px;
  height: 345px;
  }
  .desc {
  position: absolute;
  width: 100%;
  height: 40px;
  line-height: 40px;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  padding-left: 10px;
  }
  a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 70%;
    color: #fff;
  }
  a:hover {
    text-decoration: underline;
    cursor: pointer;
  }

.swipper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-wrapper {
  width: 655px;
  height: 345px;
  box-shadow: 1px 1px 4px #ccc;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #ccc;
  background-color: #fff;
}

.news-wrapper .img {
  cursor: pointer;
}

.news-header {
  width: 100%;
  height: 44px;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  color: #999;
}

.header-item {
  height: 100%;
  margin-right: 40px;
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  display: flex;
  align-items: center;
}

.header-item:hover {
  cursor: pointer;
}

.header-item-active {
  border-bottom: 2px solid rgb(28,59,133);
  color: rgb(28,59,133);
}

.news-item-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Microsoft YaHei";
  /*color: #999;*/
  padding: 5px 0;
  flex: 1;
  width: 100%;
}

.news-item-line > span:first-child {
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.news-item-desc {
  padding: 14px 4px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  border-bottom: 1px solid #ccc;
}

.news-content{
  flex: 1;
  padding-right: 40px;
}

.new{
  /*flex: 1;*/
  position: relative;
  padding-right: 50px;
  box-sizing: border-box;
}

.new:after{
  content: 'New';
  position: absolute;
  color: #333333;
  font-size: 10px;
  padding: 3px 5px;
  border-radius: 3px;
  margin-left: 3px;
  animation: text 2s;
  animation-iteration-count: infinite;
}

.news-item-desc > span:first-child {
  display: block;
  font-size: 18px;
  color: rgb(28,59,133);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.news-item-desc > span:last-child {
  display: block;
  margin-top: 12px;
  font-size: 16px;
  color: #666666;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 24px;
}

.news-item-line,
.news-item-desc span:hover {
  cursor: pointer;
}
</style>
